import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useCopyToClipboard, useNotification } from '../../../hooks'
import { isClipboardWriteSupported } from '../../../utils/clipboard'
import { stopPropagation } from '../../../utils/events'
import { AIButtonTextGrey } from '../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { ICON_HEIGHT_20 } from '../../Icon'

import {
  AI_SUMMARY_COPY_BUTTON_DISABLED_TIMEOUT,
  QA_NAME_COPY_SUMMARY_BUTTON,
} from './ProfileAISummaryWidgetFooterCopyButton.constants'

import CopyIcon from '../../../icons/copy.svg'

function ProfileAISummaryWidgetFooterCopyButton({ className, contentRef }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const [copied, setCopied] = useState(false)

  const timerRef = useRef(null)

  function handleCopySuccess() {
    setCopied(true)

    handleAddSuccessNotification(
      'Notification.ProfileAISummaryWidgetTextCopiedKey'
    )

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setCopied(false)
    }, AI_SUMMARY_COPY_BUTTON_DISABLED_TIMEOUT)
  }

  const [, copy] = useCopyToClipboard({ onSuccess: handleCopySuccess })

  useEffect(() => () => clearTimeout(timerRef.current), [])

  function handleCopy(event) {
    stopPropagation(event)

    const node = contentRef.current

    const content = node?.innerText.trim()

    if (content) {
      copy(content, { html: node.innerHTML })
    }
  }

  return isClipboardWriteSupported() ? (
    <AIButtonTextGrey
      beforeIconProps={{
        Icon: CopyIcon,
        height: ICON_HEIGHT_20,
      }}
      className={className}
      disabled={copied}
      height={BUTTON_HEIGHT_24}
      qaName={QA_NAME_COPY_SUMMARY_BUTTON}
      text={t('Common.CopyButtonTextKey')}
      tooltip={t('Common.ProfileWidgetAISummaryCopyButtonTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleCopy}
    />
  ) : null
}

export default ProfileAISummaryWidgetFooterCopyButton
